import { X, FileText, Image as ImageIcon, FileSpreadsheet, File } from "lucide-react";
import { Button } from "@/components/ui/button";

interface FileAttachmentPreviewProps {
  file: File;
  onRemove: () => void;
}

const getFileIcon = (type: string) => {
  if (type.startsWith('image/')) return ImageIcon;
  if (type.includes('pdf')) return FileText;
  if (type.includes('spreadsheet') || type.includes('csv')) return FileSpreadsheet;
  return File;
};

const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

export const FileAttachmentPreview = ({ file, onRemove }: FileAttachmentPreviewProps) => {
  const Icon = getFileIcon(file.type);
  const isImage = file.type.startsWith('image/');
  const previewUrl = isImage ? URL.createObjectURL(file) : null;

  return (
    <div className="flex items-center gap-2 p-2 pr-1 bg-muted rounded-lg group">
      {previewUrl ? (
        <img
          src={previewUrl}
          alt={file.name}
          className="w-10 h-10 object-cover rounded"
          onLoad={() => URL.revokeObjectURL(previewUrl)}
        />
      ) : (
        <Icon className="w-5 h-5 text-muted-foreground shrink-0" />
      )}
      
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium truncate">{file.name}</p>
        <p className="text-xs text-muted-foreground">{formatFileSize(file.size)}</p>
      </div>
      
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="h-6 w-6 shrink-0"
        onClick={onRemove}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};
